export default __webpack_public_path__ + "static/media/slider2.5aac036d.jpeg";